import $ from 'jquery'

$(document).ready(function() {
  co_vc_handwerkersuche()
})

function co_vc_handwerkersuche() {
  $('.co_vc_handwerkersuche').each(function() {})
}
